import Typography from "../Typography/Typography";
import { TargetCardStyle } from "./TargetCardStyle";

const TargetCard = ({ bgColor, title, value }) => {
  return (
    <TargetCardStyle bgColor={bgColor}>
      <Typography
        className="title mb-2"
        size="20px"
        weight="bold"
        primary="#fff"
      >
        {title}
      </Typography>
      <Typography className="value" primary="#fff">
        {value}
      </Typography>
    </TargetCardStyle>
  );
};

export default TargetCard;
